import type { BadgeToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useBadgeTokens = (theme: Theme): BadgeToken => {
  const { color, borderRadius, component } = theme;
  const base = {
    number: {
      backgroundColor: color.negative,
      textColor: color.onNegative,
      borderRadius: '100px',
      borderStyle: 'none',
      borderWidth: '1px',
      borderColor: color.negative,
    },
    text: {
      borderRadius: borderRadius.sm,
      borderStyle: 'none',
      borderWidth: '1px',
      neutral: {
        backgroundColor: color.supportOneVariant,
        textColor: color.supportOneOnVariant,
        borderColor: color.supportOneVariant,
      },
      positive: {
        backgroundColor: color.positiveVariant,
        textColor: color.onPositiveVariant,
        borderColor: color.positiveVariant,
      },
      warning: {
        backgroundColor: color.warningVariant,
        textColor: color.onWarningVariant,
        borderColor: color.warningVariant,
      },
      negative: {
        backgroundColor: color.negativeVariant,
        textColor: color.onNegativeVariant,
        borderColor: color.negativeVariant,
      },
      gray: {
        backgroundColor: color.surfaceContainer,
        textColor: color.onSurface,
      },
      supportOne: {
        backgroundColor: color.supportOneNewVariant,
        textColor: color.supportOneOnNewVariant,
        borderColor: color.supportOneNewVariant,
      },
      supportTwo: {
        backgroundColor: color.supportTwoVariant,
        textColor: color.supportTwoOnVariant,
        borderColor: color.supportTwoVariant,
      },
      supportThree: {
        backgroundColor: color.supportThreeVariant,
        textColor: color.supportThreeOnVariant,
        borderColor: color.supportThreeVariant,
      },
      supportFour: {
        backgroundColor: color.supportFourVariant,
        textColor: color.supportFourOnVariant,
        borderColor: color.supportFourVariant,
      },
      supportFive: {
        backgroundColor: color.supportFiveVariant,
        textColor: color.supportFiveOnVariant,
        borderColor: color.supportFiveVariant,
      },
      supportSix: {
        backgroundColor: color.supportSixVariant,
        textColor: color.supportSixOnVariant,
        borderColor: color.supportSixVariant,
      },
    },
  };

  return merge({}, base, component?.badge) as BadgeToken;
};
